import { LocationChessFeature } from '@/core/data/location/location.type';

export function isLocationValid(payload: any) {
  if (!payload) return;

  const { form } = payload || {};
  const {
    name,
    address,
    coordinates,
    type,
    chessFeatures,
    chessSetCount,
    chessClockCount,
    chessTableCount,
    giantChessBoardCount,
    giantChessPieces,
  } = form || {};

  let isValid = true;

  // Name and address are required
  if (!name || !address) isValid = false;

  // Must select a location type
  if (!Array.isArray(type) || type.length === 0) {
    isValid = false;
  }

  // Coordinates are required
  // TODO: Ensure coordinates are cast as floating point numbers
  if (!coordinates || !coordinates.lat || !coordinates.lng) isValid = false;

  // If the location is marked as having portable chess sets, require a non-zero value
  if (
    Array.isArray(chessFeatures) &&
    chessFeatures.includes(LocationChessFeature.CHESS_SET) &&
    typeof chessSetCount !== 'number'
  )
    isValid = false;

  // If the location is marked as having chess clocks, require a non-zero value
  if (
    Array.isArray(chessFeatures) &&
    chessFeatures.includes(LocationChessFeature.CHESS_CLOCK) &&
    typeof chessClockCount !== 'number'
  )
    isValid = false;

  // If the location is marked as having chess tables, require a non-zero value
  if (
    Array.isArray(chessFeatures) &&
    chessFeatures.includes(LocationChessFeature.CHESS_TABLE) &&
    typeof chessTableCount !== 'number'
  )
    isValid = false;

  // If the location is marked as having giant chess sets, require a non-zero value
  if (
    Array.isArray(chessFeatures) &&
    chessFeatures.includes(LocationChessFeature.GIANT_CHESS) &&
    (typeof giantChessBoardCount !== 'number' || typeof giantChessPieces !== 'boolean')
  )
    isValid = false;

  return isValid;
}
